import EmbedNamePromiseModalView from './EmbedNamePromiseModalView'
import {EmbedPromiseModalProps} from './types'
import React from 'react'

const EmbedNamePromiseModal = (props: EmbedPromiseModalProps) => <EmbedNamePromiseModalView {...props} />

export default EmbedNamePromiseModal
